module.exports = __webpack_public_path__ + "img/inboxes.86af5882.svg";